import React, { useState, useEffect } from "react";
import { OI_URL } from "../../config/config";
import { Modal, Button, Form, Input, Select } from "antd";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

const { Option } = Select;

const EditBinCaidModal = (props) => {
    const { 
        t, 
        fetchBinCaids, 
        isEditModalVisible, 
        setIsEditModalVisible, 
        binCaid,
        merchantList
    } = props;
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [form] = Form.useForm();

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 16 },
    };

    // Initialize form with BIN/CAID data when it becomes available
    useEffect(() => {
        if (binCaid) {
            form.setFieldsValue(binCaid);
        }
    }, [binCaid, form]);

    const handleOk = () => {
        form.validateFields()
            .then(values => {
                onFinish(values);
            })
            .catch(info => {
                console.log('Validate Failed:', info);
            });
    };

    const onFinish = async (values) => {
        setIsSubmitting(true);
        const apiUrl = OI_URL + `/api/v1/txshield/bincaid/${binCaid.bincaidId}`;

        try {
            // Include the descriptorId in the update if it exists
            const payload = {
                ...values,
                descriptorId: binCaid?.descriptorId || null
            };
            
            const { data } = await axios.put(
                apiUrl, 
                payload, 
                { headers: { Authorization: "Bearer " + Cookies.get("txfind_token") } }
            );
            
            if (data.status === "ok") {
                Swal.fire({
                    icon: "success",
                    title: t("contents.oi.bincaid_updated"),
                    showConfirmButton: false,
                    timer: 2000,
                    onClose: () => {
                        // Refresh data after successful update
                        if (fetchBinCaids && typeof fetchBinCaids === 'function') {
                            fetchBinCaids();
                        }
                        
                        // Close modal
                        handleCancel();
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: t("login.dialogs.catch"),
                    text: data.msg ? data.msg : "",
                    showConfirmButton: true,
                });
            }
        } catch (error) {
            console.error("Error updating BIN/CAID:", error);
            Swal.fire({
                icon: "error",
                title: t("login.dialogs.catch"),
                text: error.response ? error.response.data.msg : "",
                showConfirmButton: true,
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleCancel = () => {
        form.resetFields();
        setIsEditModalVisible(false);
    };

    return (
        <Modal
            title={t("contents.oi.edit_bincaid")}
            width={600}
            visible={isEditModalVisible}
            onCancel={handleCancel}
            destroyOnClose={true} // Destroy modal when closed to prevent state issues
            footer={[
                <Button key="back" onClick={handleCancel}>
                    {t("contents.chargebacks.form.cancel")}
                </Button>,
                <Button 
                    key="submit" 
                    type="primary" 
                    loading={isSubmitting} 
                    onClick={handleOk}
                >
                    {isSubmitting ? t("contents.oi.form.updating") : t("contents.oi.form.update")}
                </Button>,
            ]}
        >
            <Form 
                form={form} 
                {...layout} 
                name="edit_bincaid" 
                values={binCaid}
            >
                <Form.Item name="bin" label={t("contents.oi.form.bin")} rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="caid" label={t("contents.oi.form.caid")} rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="mcc" label="MCC" rules={[{ required: true }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="status" label={t("contents.oi.form.status")} rules={[{ required: true }]}>
                    <Select placeholder={t("contents.merchants.form.please_select")}>
                        <Option value="REQUESTED">REQUESTED</Option>
                        <Option value="PENDING">PENDING</Option>
                        <Option value="ENROLLED">ENROLLED</Option>
                    </Select>
                </Form.Item>
                <Form.Item name="merchantId" label={t("contents.oi.form.merchant")} rules={[{ required: true }]}>
                    <Select placeholder={t("contents.merchants.form.please_select")}>
                        {merchantList && merchantList.map((item) => (
                            <Option key={item.merchantId} value={item.merchantId}>
                                {item.name}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name="referenceNumber" label={t("contents.oi.form.referenceNumber")} rules={[{ required: true }]}>
                    <Input />
                </Form.Item>

                {/* Hidden field for descriptorId if present */}
                {binCaid?.descriptorId && (
                    <Form.Item name="descriptorId" hidden={true}>
                        <Input />
                    </Form.Item>
                )}
            </Form>
        </Modal>
    );
};

export default EditBinCaidModal;